module.exports = __webpack_public_path__ + "static/ClickedNo-3164ab03d5f6cd6095d92b61b775d6e9.png";